export default __webpack_public_path__ + "static/media/ithiri_m_2.5508c413.png";